export default "__VITE_ASSET__BvZONWqN__"